var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.2 18.6c-.2 0-.3-.1-.4-.2l-9.1-9c-.2-.2-.2-.6 0-.8s.6-.2.8 0l8.6 8.6 8.2-8.6c.2-.2.6-.2.8 0s.2.6 0 .8l-8.7 9.1c.1.1 0 .1-.2.1"
})));
export default SvgArrowDown;